import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../../util/errors';
import { updatePasswordSupabase } from '../../util/api';

// ================ Async thunk ================ //

export const resetPasswordThunk = createAsyncThunk(
  'PasswordResetPage/resetPassword',
  async ({ newPassword }, { rejectWithValue }) => {
    try {
      await updatePasswordSupabase({ password: newPassword });
      return {};
    } catch (e) {
      return rejectWithValue(storableError(e));
    }
  }
);

export const resetPassword = newPassword => dispatch => {
  return dispatch(resetPasswordThunk({ newPassword })).unwrap();
};

// ================ Slice ================ //

const passwordResetSlice = createSlice({
  name: 'PasswordResetPage',
  initialState: {
    resetPasswordInProgress: false,
    resetPasswordError: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(resetPasswordThunk.pending, state => {
        state.resetPasswordInProgress = true;
        state.resetPasswordError = null;
      })
      .addCase(resetPasswordThunk.fulfilled, state => {
        state.resetPasswordInProgress = false;
      })
      .addCase(resetPasswordThunk.rejected, (state, action) => {
        console.error(action.payload); // eslint-disable-line no-console
        state.resetPasswordInProgress = false;
        state.resetPasswordError = action.payload;
      });
  },
});

export default passwordResetSlice.reducer;
